import React, { SVGProps } from 'react'
import withIcon from './hoc/withIcon'

const Lanage: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.28379 4.22348C7.1908 3.99849 6.97109 3.85199 6.72764 3.85266C6.4842 3.85333 6.26529 4.00103 6.17353 4.22652L4.92446 7.29622L4.31173 8.73695C4.18204 9.04189 4.32411 9.39423 4.62905 9.52391C4.93399 9.6536 5.28633 9.51153 5.41601 9.20659L5.87527 8.12671H7.60806L8.08534 9.21311C8.21863 9.51649 8.57262 9.65438 8.876 9.5211C9.17939 9.38781 9.31728 9.03382 9.18399 8.73044L8.5518 7.29143L7.28379 4.22348ZM7.1026 6.92671H6.37035L6.73362 6.03396L7.1026 6.92671Z"
        fill="#415066"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.63147 3.20654C1.63147 2.33665 2.33665 1.63147 3.20654 1.63147H10.3174C11.1873 1.63147 11.8925 2.33665 11.8925 3.20654V10.3174C11.8925 11.1873 11.1873 11.8925 10.3174 11.8925H3.20654C2.33665 11.8925 1.63147 11.1873 1.63147 10.3174V3.20654ZM3.20654 2.74992C2.95435 2.74992 2.74992 2.95435 2.74992 3.20654V10.3174C2.74992 10.5696 2.95435 10.774 3.20654 10.774H10.3174C10.5696 10.774 10.7741 10.5696 10.7741 10.3174V3.20654C10.7741 2.95435 10.5696 2.74992 10.3174 2.74992H3.20654Z"
        fill="#415066"
      />
      <path
        d="M14.0004 6.73327C14.3318 6.73327 14.6004 7.0019 14.6004 7.33327V11.6673C14.6004 13.2873 13.2871 14.6006 11.6671 14.6006H7.28054C6.94917 14.6006 6.68054 14.332 6.68054 14.0006C6.68054 13.6692 6.94917 13.4006 7.28054 13.4006H11.6671C12.6244 13.4006 13.4004 12.6245 13.4004 11.6673V7.33327C13.4004 7.0019 13.6691 6.73327 14.0004 6.73327Z"
        fill="#415066"
      />
    </svg>
  )
}

Lanage.displayName = 'Lanage'

export default withIcon(Lanage)
